import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, PopoverController, AlertCmp, AlertController, ModalController, ToastController } from 'ionic-angular';
import { GN } from '../../../../gn';
import { DIC } from '../../../dic';
import * as moment from 'moment';
import { CalendarPage } from '../../../calendar/calendar';
import { PopupPage } from '../../../popup/popup';
import { ChoosedriverbankPage } from '../choosedriverbank/choosedriverbank';
import { LoadpredefinedPage } from '../../loadpredefined/loadpredefined';
import { SuccsavedorderPage } from '../../../succsavedorder/succsavedorder';

/**
 * Generated class for the NeworderbankPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-neworderbank',
  templateUrl: 'neworderbank.html',
})
export class NeworderbankPage {
  @ViewChild('mySearchInput') mySearchInput;
  Title = ''
  preddata = []

  startDateA: any = new Date()
  startDateStrA: any = moment(new Date()).format(this.gn.user.DFormat)
  selectedTime = new Date().getHours() + 1 + ":00";
  selectedVehicleName = '--- ' + this.dic.l["choosevehicle"] + ' ---';
  selectedVehicleID = -1;
  selectedBreak = '--- Изберете пауза ---';
  selectedBreakIds = []
  _Pauses = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60]
  SelPauses = []
  idle: any = '1';
  RouteTitle = ''
  Drivers = []

  InFocused = false
  AutoCompleteShow2 = false
  AutoCompleteState2 = 0
  LoadingDataSearch2 = false
  mapSearcData2 = []
  AutoCompleteTitle = ''
  r_routeName = ''

  Points = []
  PointsSave = []

  RouteTotalDistance = 0
  _totaltime = 0
  _ctmp = 0
  selectedCultureStr = ''
  selectedCultureId = 0
  selectedOperationStr = ''
  selectedOperationId = 0
  selectedMaterialStr = ''
  selectedMaterialId = 0
  selectedMechanStr = ''
  selectedMechanId = 0

  EditId = -1
  EditNum = ''
  EditType = 'new'

  ref;
  onlyloc = false;
  driverUser = '-1'
  driveridvar = ''
  changePointFlag = false
  oldPoint: any
  indexPoint: any
  se: any
  hasChanges = false;
  cntdata = 0;
  loadingData: boolean = false

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public popoverCtrl: PopoverController, public alertCtrl: AlertController, public modalCtrl: ModalController, public toastCtrl: ToastController) {
    this.Title = 'Нов налог'
    var tmpid = this.navParams.get('id')
    if (tmpid != null) {
      this.EditId = tmpid
      this.EditType = this.navParams.get('edittype')
      console.log(this.EditType, 'this.EditType')
      this.ref = this.navParams.get('ref')
      this.Title = 'Промена на налог: ' + tmpid
      //this.preddata = this.navParams.get('preddata')

      //edit na predefiniran nalog
      if (this.EditType == 'pre') {
        this.RouteTitle = this.navParams.get('preddata').name

        this.startDateA = this.navParams.get('preddata').startdate
        this.startDateStrA = moment(this.navParams.get('preddata').startdate).format(this.gn.user.DFormat)

        this.selectedTime = moment(this.navParams.get('preddata').startdate).format('HH:mm')
        this.selectedVehicleName = this.navParams.get('preddata').vehicle
        this.selectedVehicleID = this.navParams.get('preddata').vehicleid

        var tmpPauses = []
        if (this.navParams.get('preddata').pause1 != 0) {
          tmpPauses.push(this.navParams.get('preddata').pause1 + ' ' + this.dic.l["min"])
          this.SelPauses.push(this.navParams.get('preddata').pause1)
        }
        if (this.navParams.get('preddata').pause2 != 0) {
          tmpPauses.push(this.navParams.get('preddata').pause2 + ' ' + this.dic.l["min"])
          this.SelPauses.push(this.navParams.get('preddata').pause2)
        }
        if (this.navParams.get('preddata').pause3 != 0) {
          tmpPauses.push(this.navParams.get('preddata').pause3 + ' ' + this.dic.l["min"])
          this.SelPauses.push(this.navParams.get('preddata').pause3)
        }
        if (this.navParams.get('preddata').pause4 != 0) {
          tmpPauses.push(this.navParams.get('preddata').pause4 + ' ' + this.dic.l["min"])
          this.SelPauses.push(this.navParams.get('preddata').pause4)
        }
        if (this.navParams.get('preddata').pause5 != 0) {
          tmpPauses.push(this.navParams.get('preddata').pause5 + ' ' + this.dic.l["min"])
          this.SelPauses.push(this.navParams.get('preddata').pause5)
        }

        this.selectedBreak = tmpPauses.join(', ')
        // selectedBreakIds = []

        this.idle = this.navParams.get('preddata').tostay
        if (this.navParams.get('preddata').driver1 != null && this.navParams.get('preddata').driver1 != undefined) {
          this.Drivers.push({
            Driver: this.navParams.get('preddata').driver1,
            DriverId: this.navParams.get('preddata').driverid1,
            Weapon: this.navParams.get('preddata').weapon1 == null ? 0 : this.navParams.get('preddata').weapon1,
            WeaponId: this.navParams.get('preddata').weaponid1 == null ? 0 : this.navParams.get('preddata').weaponid1,
            Position: this.navParams.get('preddata').jobname1 == null ? 0 : this.navParams.get('preddata').jobname1,
            PositionId: this.navParams.get('preddata').job1 == null ? 0 : this.navParams.get('preddata').job1
          })
        }
        if (this.navParams.get('preddata').driver2 != null && this.navParams.get('preddata').driver2 != undefined) {
          this.Drivers.push({
            Driver: this.navParams.get('preddata').driver2,
            DriverId: this.navParams.get('preddata').driverid2,
            Weapon: this.navParams.get('preddata').weapon2 == null ? 0 : this.navParams.get('preddata').weapon2,
            WeaponId: this.navParams.get('preddata').weaponid2 == null ? 0 : this.navParams.get('preddata').weaponid2,
            Position: this.navParams.get('preddata').jobname2 == null ? 0 : this.navParams.get('preddata').jobname2,
            PositionId: this.navParams.get('preddata').job2 == null ? 0 : this.navParams.get('preddata').job2
          })
        }
        if (this.navParams.get('preddata').driver3 != null && this.navParams.get('preddata').driver3 != undefined) {
          this.Drivers.push({
            Driver: this.navParams.get('preddata').driver3,
            DriverId: this.navParams.get('preddata').driverid3,
            Weapon: this.navParams.get('preddata').weapon3 == null ? 0 : this.navParams.get('preddata').weapon3,
            WeaponId: this.navParams.get('preddata').weaponid3 == null ? 0 : this.navParams.get('preddata').weaponid3,
            Position: this.navParams.get('preddata').jobname3 == null ? 0 : this.navParams.get('preddata').jobname3,
            PositionId: this.navParams.get('preddata').job3 == null ? 0 : this.navParams.get('preddata').job3
          })
        }
        if (this.navParams.get('preddata').driver4 != null && this.navParams.get('preddata').driver4 != undefined) {
          this.Drivers.push({
            Driver: this.navParams.get('preddata').driver4,
            DriverId: this.navParams.get('preddata').driverid4,
            Weapon: this.navParams.get('preddata').weapon4 == null ? 0 : this.navParams.get('preddata').weapon4,
            WeaponId: this.navParams.get('preddata').weaponid4 == null ? 0 : this.navParams.get('preddata').weaponid4,
            Position: this.navParams.get('preddata').jobname4 == null ? 0 : this.navParams.get('preddata').jobname4,
            PositionId: this.navParams.get('preddata').job4 == null ? 0 : this.navParams.get('preddata').job4
          })
        }

        var tmpPois = this.navParams.get('preddata').npois
        for (var i = 0; i < tmpPois.length; i++) {

          // var pnt1 = '{"txt":"' + tmpPois[i].split('#')[1] + '", "lon":"-1", "lat":"-1", "ppid":"' + tmpPois[i].split('#')[5] + '", "checked":"' + tmpPois[i].split('#')[4] + '"}'
          // this.PointsSave.push(pnt1)
          // if (tmpPois[i + 1] != undefined) {
          //   var pnt2 = '{"txt":"' + tmpPois[i + 1].split('#')[1] + '", "lon":"-1", "lat":"-1", "ppid":"' + tmpPois[i + 1].split('#')[5] + '", "checked":"' + tmpPois[i + 1].split('#')[4] + '"}'
          //   this.PointsSave.push(pnt2)
          // }

          this.Points.push({
            t1: {
              name: tmpPois[i].split('#')[1],
              lon: tmpPois[i].split('#')[2],
              lat: tmpPois[i].split('#')[3],
              ppid: tmpPois[i].split('#')[5],
              chk: tmpPois[i].split('#')[4] + '' == '1' ? true : false,
              note: tmpPois[i].note,
              noteid: tmpPois[i].notesid,
              appcolor: tmpPois[i].split('#')[6],
            },
            t2: {
              name: tmpPois[i + 1] != undefined ? tmpPois[i + 1].split('#')[1] : '-',
              lon: tmpPois[i + 1] != undefined ? tmpPois[i + 1].split('#')[2] : 0,
              lat: tmpPois[i + 1] != undefined ? tmpPois[i + 1].split('#')[3] : 0,
              ppid: tmpPois[i + 1] != undefined ? tmpPois[i + 1].split('#')[5] : 0,
              chk: tmpPois[i + 1] != undefined ? (tmpPois[i + 1].split('#')[4] + '' == '1' ? true : false) : false,
              note: tmpPois[i + 1].note,
              noteid: tmpPois[i + 1].noteid,
              appcolor: tmpPois[i + 1] != undefined ? tmpPois[i + 1].split('#')[6] : '',
            }
          })
          i += 1;
        }
        //edit na nalog od pregled na nalozi
      } else {
        this.RouteTotalDistance = this.navParams.get('routedata').totalkm
        this._totaltime = this.navParams.get('routedata').totaltime
        // presmetka za realno vreme na totaltime
        var vkupnotostayMnoziPOI
        var vkupnoMinusTotalTime = this.navParams.get('routedata').pause1 + this.navParams.get('routedata').pause2 + this.navParams.get('routedata').pause3 + this.navParams.get('routedata').pause4 + this.navParams.get('routedata').pause5
        vkupnotostayMnoziPOI = this.navParams.get('routedata').tostay * this.navParams.get('routedata').pois.length
        vkupnoMinusTotalTime = (vkupnoMinusTotalTime * 60) + (vkupnotostayMnoziPOI * 60)

        this._totaltime = this._totaltime - vkupnoMinusTotalTime

        // this._totaltime = this._totaltime - this.navParams.get('routedata').tostay 

        this.RouteTitle = this.navParams.get('routedata').routetitle
        this.startDateA = this.navParams.get('routedata').startdate
        this.startDateStrA = moment(this.navParams.get('routedata').startdate).format(this.gn.user.DFormat)
        this.selectedTime = moment(this.navParams.get('routedata').startdate).format('HH:mm')
        this.selectedVehicleName = this.navParams.get('routedata').vozilo //vehicle
        this.selectedVehicleID = this.navParams.get('routedata').vehicleid

        var tmpPauses = []
        if (this.navParams.get('routedata').pause1 != 0) {
          tmpPauses.push(this.navParams.get('routedata').pause1 + ' ' + this.dic.l["min"])
          this.SelPauses.push(this.navParams.get('routedata').pause1)
        }
        if (this.navParams.get('routedata').pause2 != 0) {
          tmpPauses.push(this.navParams.get('routedata').pause2 + ' ' + this.dic.l["min"])
          this.SelPauses.push(this.navParams.get('routedata').pause2)
        }
        if (this.navParams.get('routedata').pause3 != 0) {
          tmpPauses.push(this.navParams.get('routedata').pause3 + ' ' + this.dic.l["min"])
          this.SelPauses.push(this.navParams.get('routedata').pause3)
        }
        if (this.navParams.get('routedata').pause4 != 0) {
          tmpPauses.push(this.navParams.get('routedata').pause4 + ' ' + this.dic.l["min"])
          this.SelPauses.push(this.navParams.get('routedata').pause4)
        }
        if (this.navParams.get('routedata').pause5 != 0) {
          tmpPauses.push(this.navParams.get('routedata').pause5 + ' ' + this.dic.l["min"])
          this.SelPauses.push(this.navParams.get('routedata').pause5)
        }

        this.selectedBreak = tmpPauses.join(', ')

        this.idle = this.navParams.get('routedata').tostay
        if (this.navParams.get('routedata').s1 != null && this.navParams.get('routedata').s1 != undefined) {
          this.Drivers.push({
            Driver: this.navParams.get('routedata').s1,
            DriverId: this.navParams.get('routedata').driverid1,
            Weapon: this.navParams.get('routedata').weapon1 == null ? 0 : this.navParams.get('routedata').weapon1,
            WeaponId: this.navParams.get('routedata').weaponid1 == null ? 0 : this.navParams.get('routedata').weaponid1,
            Position: this.navParams.get('routedata').jobname1 == null ? 0 : this.navParams.get('routedata').jobname1,
            PositionId: this.navParams.get('routedata').job1 == null ? 0 : this.navParams.get('routedata').job1
          })
        }
        if (this.navParams.get('routedata').s2 != null && this.navParams.get('routedata').s2 != undefined) {
          this.Drivers.push({
            Driver: this.navParams.get('routedata').s2,
            DriverId: this.navParams.get('routedata').driverid2,
            Weapon: this.navParams.get('routedata').weapon2 == null ? 0 : this.navParams.get('routedata').weapon2,
            WeaponId: this.navParams.get('routedata').weaponid2 == null ? 0 : this.navParams.get('routedata').weaponid2,
            Position: this.navParams.get('routedata').jobname2 == null ? 0 : this.navParams.get('routedata').jobname2,
            PositionId: this.navParams.get('routedata').job2 == null ? 0 : this.navParams.get('routedata').job2
          })
        }
        if (this.navParams.get('routedata').s3 != null && this.navParams.get('routedata').s3 != undefined) {
          this.Drivers.push({
            Driver: this.navParams.get('routedata').s3,
            DriverId: this.navParams.get('routedata').driverid3,
            Weapon: this.navParams.get('routedata').weapon3 == null ? 0 : this.navParams.get('routedata').weapon3,
            WeaponId: this.navParams.get('routedata').weaponid3 == null ? 0 : this.navParams.get('routedata').weaponid3,
            Position: this.navParams.get('routedata').jobname3 == null ? 0 : this.navParams.get('routedata').jobname3,
            PositionId: this.navParams.get('routedata').job3 == null ? 0 : this.navParams.get('routedata').job3
          })
        }
        if (this.navParams.get('routedata').s4 != null && this.navParams.get('routedata').s4 != undefined) {
          this.Drivers.push({
            Driver: this.navParams.get('routedata').s4,
            DriverId: this.navParams.get('routedata').driverid4,
            Weapon: this.navParams.get('routedata').weapon4 == null ? 0 : this.navParams.get('routedata').weapon4,
            WeaponId: this.navParams.get('routedata').weaponid4 == null ? 0 : this.navParams.get('routedata').weaponid4,
            Position: this.navParams.get('routedata').jobname4 == null ? 0 : this.navParams.get('routedata').jobname4,
            PositionId: this.navParams.get('routedata').job4 == null ? 0 : this.navParams.get('routedata').job4
          })
        }

        var tmpPois = this.navParams.get('routedata').pois
        for (var i = 0; i < tmpPois.length; i++) {
          this.Points.push({
            t1: {
              name: tmpPois[i].name,
              lon: tmpPois[i].lon,
              lat: tmpPois[i].lat,
              ppid: tmpPois[i].id,
              chk: tmpPois[i].checked + '' == '1' ? true : false,
              note: tmpPois[i].note,
              noteid: tmpPois[i].noteid,
              appcolor: tmpPois[i].appcolor,
            },
            t2: {
              name: tmpPois[i + 1] != undefined ? tmpPois[i + 1].name : '-',
              lon: tmpPois[i + 1] != undefined ? tmpPois[i + 1].lon : 0,
              lat: tmpPois[i + 1] != undefined ? tmpPois[i + 1].lat : 0,
              ppid: tmpPois[i + 1] != undefined ? tmpPois[i + 1].id : 0,
              chk: tmpPois[i + 1] != undefined ? (tmpPois[i + 1].checked + '' == '1' ? true : false) : false,
              note: tmpPois[i + 1].note,
              noteid: tmpPois[i + 1].noteid,
              appcolor: tmpPois[i + 1].appcolor,
            }
          })
          i += 1;
        }
      }
    }
    // console.log('Nalog za editiranje: ' + this.EditId)
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NeworderbankPage');
  }

  stopCreatingRoute(_id, _editdouble) {
    var items = document.getElementsByClassName('input-edit');
    for (var i = 0; i < items.length; i++) {
      var he = <HTMLElement>items[i]
      he.style.color = '';
    }
    if (_id.indexOf('edit-poi') != -1) {
      if (_editdouble == 0) {
        var items1 = document.getElementsByClassName('input-edit1');
        for (var i = 0; i < items1.length; i++) {
          var he = <HTMLElement>items1[i]
          he.style.border = '';
          he.style.backgroundColor = '';
        }
      } else {
        var items1 = document.getElementsByClassName('input-edit1');
        for (var i = 0; i < items1.length; i++) {
          var he = <HTMLElement>items1[i]
          if (_id.split("-")[2] + '' != he.id.split("-")[2] + '') {
            he.style.border = '';
            he.style.backgroundColor = '';
          }
        }
      }
      document.getElementById(_id).style.setProperty('border', '1px solid #f53d3d', 'important');
      document.getElementById(_id).style.backgroundColor = 'rgba(250, 158, 158, 0.1)';
    } else {
      var items1 = document.getElementsByClassName('input-edit1');
      for (var i = 0; i < items1.length; i++) {
        var he = <HTMLElement>items1[i]
        he.style.border = '';
        he.style.backgroundColor = '';
      }
      document.getElementById(_id).style.setProperty('color', '#f53d3d', 'important');
    }
  }

  openDatePopup(_ev) {
    this.stopCreatingRoute('edit-dt', 0)

    var _that = this;
    let popover = this.popoverCtrl.create(CalendarPage, {
      d: this.startDateA, cb: function (d) {
        // console.log(d)
        _that.startDateA = d;
        _that.startDateStrA = moment(_that.startDateA).format(_that.gn.user.DFormat)
      }
    })
    popover.present({ ev: _ev });
  }
  openTimePopup(_ev) {
    this.stopCreatingRoute('edit-time', 0)

    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'time', selected: [], callback: function (_text, _ids) {
        // console.log(_text, _ids)
        // _that.selectedVehiclesIds = _ids
        // _that.selectedVehiclesText = _text

        _that.selectedTime = _text;

        // console.log(_that.selectedVehicleID, _that.selectedVehicleName)
      }
    });
    popover.present({
      ev: _ev
    });
  }


  openVehiclePopup(_ev) {
    this.stopCreatingRoute('edit-vehicle', 0)

    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'vehicles-routing', selected: [], callback: function (_text, _ids) {

        // console.log(_text, _ids)
        // _that.selectedVehiclesIds = _ids
        // _that.selectedVehiclesText = _text

        _that.selectedVehicleName = _text;
        _that.selectedVehicleID = parseInt(_ids);

        // console.log(_that.selectedVehicleID, _that.selectedVehicleName)
      }
    });
    popover.present({
      ev: _ev
    });
  }

  selectBreak(_ev) {
    this.stopCreatingRoute('edit-break', 0)

    var _that = this
    let alert = this.alertCtrl.create();
    alert.setTitle(this.dic.l["ChoosePause"]);
    for (var i = 0; i < this._Pauses.length; i++) {
      var ch = false
      for (var j = 0; j < this.SelPauses.length; j++) {
        if (this._Pauses[i] + '' == this.SelPauses[j] + '') {
          ch = true
        }
      }
      alert.addInput({
        type: 'checkbox',
        label: this._Pauses[i] + ' ' + this.dic.l["min"],
        value: this._Pauses[i] + '',
        checked: ch
      });
    }


    alert.addButton(this.dic.l['cancel']);
    alert.addButton({
      text: this.dic.l['ok'],
      handler: data => {
        //selectedBreak
        _that.SelPauses = data
        if (data.length == 0) {
          _that.selectedBreak = '-- ' + _that.dic.l["ChoosePause"] + ' --'
        } else {
          var tmp = []
          // for (var i = 0; i < _that.DriversData.length; i++) {
          for (var j = 0; j < data.length; j++) {
            // if (_that.DriversData[i].id + '' == data[j] + '') {
            tmp.push(data[j] + ' ' + _that.dic.l["min"])
            // }
          }
          // }
          _that.selectedBreak = tmp.join(', ')
        }
      }
    });
    alert.present();
  }


  zadrziTocka(_min: any, _ev) {
    this.stopCreatingRoute('edit-keeping', 0)
    this.idle = _min;
  }


  selectEkipa(_ev) {
    this.stopCreatingRoute('edit-ekipa', 0)
    if (this.Drivers.length == 4) {
      return false;
    }
    var _that = this

    const modal = this.modalCtrl.create(ChoosedriverbankPage, {
      selDriver: this.Drivers,
      cb: function (_selectedDriver, _selectedDriverIds, _selectedWeapon, _selectedWeaponId, _selectedPosition, _selectedPositionId) {

        _that.Drivers.push({
          Driver: _selectedDriver,
          DriverId: _selectedDriverIds,
          Weapon: _selectedWeapon,
          WeaponId: _selectedWeaponId,
          Position: _selectedPosition,
          PositionId: _selectedPositionId
        })
      }
    });

    modal.present();

  }
  removeDriver(_idx) {
    this.Drivers.splice(_idx, 1)
  }


  searchGeocode2(txt) {

    // console.log('searchGeocode2 koga vlagas tuka')
    txt = txt.toLowerCase()
    // txt = txt.replace(/ /g,'%')
    // console.log(txt)
    if (txt == '' || txt.length <= 3) {
      this.mapSearcData2 = []
      this.AutoCompleteState2 = 0
      return
    }
    var _that = this
    var _lon = 21.431068
    var _lat = 41.995759

    this.LoadingDataSearch2 = true
    _that.AutoCompleteState2 = 1

    if (txt != '' && txt.length > 3) {
      this.gn.Socket.emit({ query: txt, lon: _lon, lat: _lat, clientid: this.gn.user.ClientId }, function (_data) {
        _that.mapSearcData2 = []
        for (var i = 0; i < _data.length; i++) {
          if (_data[i].ppid + '' != '0') {
            _that.mapSearcData2.push(_data[i])
          }
        }
        // console.log(_that.mapSearcData2)
        _that.LoadingDataSearch2 = false
        if (_that.mapSearcData2.length == 0) {
          _that.AutoCompleteState2 = 2
        } else {
          _that.AutoCompleteState2 = 1
        }
        // console.log(_that.mapSearcData, 'that mapsearchdata')
      }, 'getgeocodenlb')
    }
  }

  openAutocomplete2(_ev) {
    this.mapSearcData2 = []
    this.LoadingDataSearch2 = false
    this.AutoCompleteState2 = 0

    this.InFocused = true
    var _txt = _ev.target.value
    if (_txt == '') {
      _txt = this.dic.l['Search'] + '...'
      this.AutoCompleteState2 = 0
    } else {
      _txt = this.dic.l['Search'] + ': ' + _txt
      this.AutoCompleteState2 = 1
    }
    this.searchGeocode2(_ev.target.value)
    // this.AutoCompleteTitle2 = _txt
    // var _top = _ev.target.parentNode.parentNode.parentNode.parentNode.parentNode.offsetTop
    this.AutoCompleteShow2 = true
    // this.AutoCompleteTop = (_top + 71) + 'px'
  }
  hideAutocomplete2() {
    //if (this.r_routeName == '') { this.selectedPoiRep = null }
    this.InFocused = false
    var _that = this
    setTimeout(function () {
      if (_that.InFocused == false) {
        _that.AutoCompleteShow2 = false
      }
    }, 150)
    // this.AutoCompleteShow = false
  }
  txtchange2(_ev) {
    var _txt = _ev.target.value
    var t = _ev.target.value
    if (_txt == '') {
      _txt = this.dic.l['Search'] + '...'
    } else {
      _txt = this.dic.l['Search'] + ': ' + _txt
    }
    // this.AutoCompleteTitle = _txt


    // var _that = this
    if (t != '') {
      this.searchGeocode2(_ev.target.value)
    } else {
      this.mapSearcData2 = []
      this.AutoCompleteState2 = 0
      // console.log (_that.mapSearcData)
    }
  }

  itemACClick2(_itm) {
    this.hasChanges = true;
    console.log('itemACClick2')
    // this.changePoint = _itm
    // if (se == 's') {
    //   newName = this.Points[index].t1.name

    // } else {
    //   newName = this.Points[index].t2.name
    // }
    // debugger
    // console.log(_itm.name, 'this.changePoint.name')
    // console.log(this.oldPoint, 'this.oldPoint')

    // console.log(this.changePointFlag, 'this.changePointFlag I f ')

    if (_itm.name == this.oldPoint) {
      this.changePointFlag = false
    }
    // console.log(this.changePointFlag, 'this.changePointFlag II promena na flag')
    if (this.changePointFlag == true) {
      console.log(this.Points, 'this.Points vo item click')
      if (this.se == 's') {
        // this.Points[this.indexPoint].t1
        this.Points[this.indexPoint].t1.name = _itm.name
        this.Points[this.indexPoint].t1.lon = _itm.lon
        this.Points[this.indexPoint].t1.lat = _itm.lat
        this.Points[this.indexPoint].t1.ppid = _itm.ppid
        this.Points[this.indexPoint].t1.appcolor = _itm.appcolor

        var _that = this
        setTimeout(function () {
          _that.stopCreatingRoute('edit-poi-' + _that.indexPoint + '-1', 0)
        }, 200);
      } else {
        // this.Points[this.indexPoint].t2
        this.Points[this.indexPoint].t2.name = _itm.name
        this.Points[this.indexPoint].t2.lon = _itm.lon
        this.Points[this.indexPoint].t2.lat = _itm.lat
        this.Points[this.indexPoint].t2.ppid = _itm.ppid
        this.Points[this.indexPoint].t2.appcolor = _itm.appcolor

        var _that = this
        setTimeout(function () {
          _that.stopCreatingRoute('edit-poi-' + _that.indexPoint + '-2', 0)
        }, 200);
      }
      this.changePointFlag = false
      // this.Points[this.indexPoint]
    }

    else {
      // changePoint: any
      // changePointFlag = false
      // newPoint: any
      // indexPoint: any
      // se:any
      // if ()
      this.AutoCompleteShow2 = false
      if (this.Points.length > 0) {
        if (this.Points[this.Points.length - 1].t2.name == '-') {

          // var pnt1 = '{"txt":"' + _itm.name + '", "lon":"' + _itm.lon + '", "lat":"' + _itm.lat + '", "ppid":"' + _itm.ppid + '", "checked":"' + true + '"}'
          // this.PointsSave.push(pnt1)

          this.Points[this.Points.length - 1].t2.name = _itm.name
          this.Points[this.Points.length - 1].t2.lon = _itm.lon
          this.Points[this.Points.length - 1].t2.lat = _itm.lat
          this.Points[this.Points.length - 1].t2.ppid = _itm.ppid
          this.Points[this.Points.length - 1].t2.appcolor = _itm.appcolor

          var _that = this
          setTimeout(function () {
            _that.stopCreatingRoute('edit-poi-' + (_that.Points.length - 1) + '-2', 0)
          }, 200);
        } else {

          // var pnt1 = '{"txt":"' + _itm.name + '", "lon":"' + _itm.lon + '", "lat":"' + _itm.lat + '", "ppid":"' + _itm.ppid + '", "checked":"' + true + '"}'
          // this.PointsSave.push(pnt1)

          this.Points.push({
            t1: {
              name: _itm.name,
              lon: _itm.lon,
              lat: _itm.lat,
              ppid: _itm.ppid,
              chk: true,
              note: '',
              noteid: -1,
              appcolor: _itm.appcolor,
            },
            // t2: {
            //   name: '-',
            //   lon: 0,
            //   lat: 0,
            //   ppid: 0,
            //   chk: false,
            //   note: '',
            //   noteid: -1,
            // }
            t2: {
              name: this.gn.centralnabaza[0].name,
              lon: this.gn.centralnabaza[0].lon,
              lat: this.gn.centralnabaza[0].lat,
              ppid: this.gn.centralnabaza[0].id,
              chk: false,
              note: '',
              noteid: -1,
              appcolor: '',
            }
          })

          var _that = this
          setTimeout(function () {
            _that.stopCreatingRoute('edit-poi-' + (_that.Points.length - 1) + '-1', 1)
            _that.stopCreatingRoute('edit-poi-' + (_that.Points.length - 1) + '-2', 1)
          }, 200);
        }
      } else {
        // var pnt1 = '{"txt":"' + _itm.name + '", "lon":"' + _itm.lon + '", "lat":"' + _itm.lat + '", "ppid":"' + _itm.ppid + '", "checked":"' + true + '"}'
        // this.PointsSave.push(pnt1)

        this.Points.push({
          t1: {
            name: _itm.name,
            lon: _itm.lon,
            lat: _itm.lat,
            ppid: _itm.ppid,
            chk: true,
            note: '',
            noteid: -1,
            appcolor: _itm.appcolor,
          },
          // t2: {
          //   name: '-',
          //   lon: 0,
          //   lat: 0,
          //   ppid: 0,
          //   chk: false,
          //   note: '',
          //   noteid: -1,
          // }
          t2: {
            name: this.gn.centralnabaza[0].name,
            lon: this.gn.centralnabaza[0].lon,
            lat: this.gn.centralnabaza[0].lat,
            ppid: this.gn.centralnabaza[0].id,
            chk: false,
            note: '',
            noteid: -1,
            appcolor: '',
          }
        })

        var _that = this
        setTimeout(function () {
          _that.stopCreatingRoute('edit-poi-' + (_that.Points.length - 1) + '-1', 1)
          _that.stopCreatingRoute('edit-poi-' + (_that.Points.length - 1) + '-2', 1)
        }, 200);
      }
    }
    // console.log(this.Points, 'points')

    // this.selectedPoiRep = { txt: '', lon: 0, lat: 0, ppid: 0 }

    // this.selectedPoiRep.txt = _itm.name
    // this.selectedPoiRep.lon = _itm.lon
    // this.selectedPoiRep.lat = _itm.lat
    // this.selectedPoiRep.ppid = _itm.ppid
    // this.r_routeName = _itm.name
    this.r_routeName = ''
    //debugger
  }

  switchItems(_idx) {
    //debugger
    this.hasChanges = true;
    var _n = this.Points[_idx].t1.name
    var _lo = this.Points[_idx].t1.lon
    var _la = this.Points[_idx].t1.lat
    var _pp = this.Points[_idx].t1.ppid
    var _appcolor = this.Points[_idx].t1.appcolor
    this.Points[_idx].t1.name = this.Points[_idx].t2.name
    this.Points[_idx].t1.lon = this.Points[_idx].t2.lon
    this.Points[_idx].t1.lat = this.Points[_idx].t2.lat
    this.Points[_idx].t1.ppid = this.Points[_idx].t2.ppid
    this.Points[_idx].t1.appcolor = this.Points[_idx].t2.appcolor

    this.Points[_idx].t2.name = _n
    this.Points[_idx].t2.lon = _lo
    this.Points[_idx].t2.lat = _la
    this.Points[_idx].t2.ppid = _pp
    this.Points[_idx].t2.appcolor = _appcolor

    var _that = this
    setTimeout(function () {
      _that.stopCreatingRoute('edit-poi-' + _idx + '-1', 1)
      _that.stopCreatingRoute('edit-poi-' + _idx + '-2', 1)
    }, 200);
  }

  reorderItems(from, to) {
    this.hasChanges = true;
    // console.log(from, to)
    let element = this.Points[from];
    this.Points.splice(from, 1);
    this.Points.splice(to, 0, element);

    var _that = this
    setTimeout(function () {
      _that.stopCreatingRoute('edit-poi-' + to + '-1', 1)
      _that.stopCreatingRoute('edit-poi-' + to + '-2', 1)
    }, 200);
  }
  removeItemDesnno(idx) {
    this.hasChanges = true;
    this.Points.splice(idx, 1)
  }
  clickradioItems(idx, nom) {
    if (nom == 1) {
      this.Points[idx].t1.chk = true
      this.Points[idx].t2.chk = false
      return
    }
    if (nom == 2) {
      this.Points[idx].t1.chk = false
      this.Points[idx].t2.chk = true
      return
    }
  }

  clearNalog() {
    // console.log('funkcija prv red')
    if (this.onlyloc == false) {
      this.startDateA = new Date()
      this.startDateStrA = moment(new Date()).format(this.gn.user.DFormat)
      this.selectedTime = new Date().getHours() + 1 + ":00";

      // console.log('funkcija vnatre fo if')

      this.RouteTitle = ''
      //this.startDateStrA = moment(new Date()).format(this.gn.user.DFormat)
      //this.selectedTime = new Date().getHours() + 1 + ":00";
      this.selectedVehicleName = '--- ' + this.dic.l["choosevehicle"] + ' ---';
      this.selectedVehicleID = -1;

      this.SelPauses = []
      this.selectedBreak = '--- Изберете пауза ---';
      // selectedBreakIds = []

      this.idle = '1';
      this.Drivers = []
    }
    this.Points = []
    this.PointsSave = []
  }

  probenclick(obj: any, index: any, se: any) {
    this.hasChanges = true;
    console.log('probenclick')
    console.log(this.Points, 'this.Point')
    this.indexPoint = index
    this.se = se
    this.changePointFlag = true
    // console.log(this.Points)
    var newName = ''
    if (se == 's') {
      newName = this.Points[index].t1.name

    } else {
      newName = this.Points[index].t2.name
    }

    this.oldPoint = newName
    this.r_routeName = ''
    this.mySearchInput.setFocus();
    this.searchGeocode2(newName)




    // if (se == 's') {
    //   this.Points[index].t1.name = this.changePoint
    //   console.log(this.Points[index].t1.name, ' this.Points[index].t1.name')

    //   // newName = this.Points[index].t1.name

    // } else {
    //   this.Points[index].t2.name = this.changePoint
    //   console.log(this.Points[index].t2.name, ' this.Points[index].t2.name')

    //   // newName = this.Points[index].t2.name
    // }



    // console.log(this.changePoint, 'this.changePoint')
    // console.log('kolku pati ke vlezes tuka')

    // this.openAutocomplete2(newName)
    // this.r_routeName.setfocus()

    // this.openAutocomplete2(newName)
    // console.log(newName)

    // this.searchGeocode2(newName)

    // debugger
    // console.log(obj, 'obj')
    // console.log(index, 'index')

  }

  setVariables(nid, pred, totaltime, totalkm) {
    console.log(totalkm, 'totalkm')
    console.log(totaltime, 'totaltime')

    var _nid = nid
    var _pred = pred

    var _that = this

    var messageDriver = false
    var dajmidriver = _that.gn.Vehicles[_that.gn.VehiclesDic[_that.selectedVehicleID]].driver
    var dajmiretistracija = _that.gn.Vehicles[_that.gn.VehiclesDic[_that.selectedVehicleID]].registration

    for (let i = 0; i < _that.Drivers.length; i++) {
      if (dajmidriver == _that.Drivers[i].Driver) {
        _that.driveridvar = _that.Drivers[i].DriverId
        messageDriver = true
        break
      }
    }

    if (messageDriver == false && dajmidriver != '/') {
      let alert = _that.alertCtrl.create({
        title: _that.dic.l["info"],
        message: 'Доделениот возач на возилото <strong>' + dajmiretistracija + '</strong> ( <strong>' + dajmidriver + ' </strong>) не е вклучен во екипата. <br> Дали сте сигурни дека сакате да продолжите?',
        buttons: [
          {
            text: _that.dic.l["NO"],
            role: 'cancel',
            handler: () => {
            }
          },
          {
            text: _that.dic.l["YES"],
            handler: () => {

              var _data = {
                drivers: _that.Drivers,
                pois: _that.Points
              }

              var dr1 = "0"; if (_that.Drivers.length >= 1) { dr1 = _that.Drivers[0].DriverId }
              var dr2 = "0"; if (_that.Drivers.length >= 2) { dr2 = _that.Drivers[1].DriverId }
              var dr3 = "0"; if (_that.Drivers.length >= 3) { dr3 = _that.Drivers[2].DriverId }
              var dr4 = "0"; if (_that.Drivers.length >= 4) { dr4 = _that.Drivers[3].DriverId }

              var j1 = "0"; if (_that.Drivers.length >= 1) { j1 = _that.Drivers[0].PositionId }
              var j2 = "0"; if (_that.Drivers.length >= 2) { j2 = _that.Drivers[1].PositionId }
              var j3 = "0"; if (_that.Drivers.length >= 3) { j3 = _that.Drivers[2].PositionId }
              var j4 = "0"; if (_that.Drivers.length >= 4) { j4 = _that.Drivers[3].PositionId }

              var w1 = "0"; if (_that.Drivers.length >= 1) { w1 = _that.Drivers[0].WeaponId }
              var w2 = "0"; if (_that.Drivers.length >= 2) { w2 = _that.Drivers[1].WeaponId }
              var w3 = "0"; if (_that.Drivers.length >= 3) { w3 = _that.Drivers[2].WeaponId }
              var w4 = "0"; if (_that.Drivers.length >= 4) { w4 = _that.Drivers[3].WeaponId }

              var p1 = "0"; if (_that.SelPauses.length >= 1) { p1 = _that.SelPauses[0] }
              var p2 = "0"; if (_that.SelPauses.length >= 2) { p2 = _that.SelPauses[1] }
              var p3 = "0"; if (_that.SelPauses.length >= 3) { p3 = _that.SelPauses[2] }
              var p4 = "0"; if (_that.SelPauses.length >= 4) { p4 = _that.SelPauses[3] }
              var p5 = "0"; if (_that.SelPauses.length >= 5) { p5 = _that.SelPauses[4] }

              var _dt = moment(_that.startDateA).format('YYYY-MM-DD') + ' ' + _that.selectedTime

              _that.PointsSave = []
              for (var i = 0; i < _that.Points.length; i++) {
                var pnt1 = '{"txt":"' + _that.Points[i].t1.name + '", "lon":"' + _that.Points[i].t1.lon + '", "lat":"' + _that.Points[i].t1.lat + '", "ppid":"' + _that.Points[i].t1.ppid + '", "checked":"' + (_that.Points[i].t1.chk == true ? '1' : '0') + '"}'
                _that.PointsSave.push(pnt1)
                var pnt2 = '{"txt":"' + _that.Points[i].t2.name + '", "lon":"' + _that.Points[i].t2.lon + '", "lat":"' + _that.Points[i].t2.lat + '", "ppid":"' + _that.Points[i].t2.ppid + '", "checked":"' + (_that.Points[i].t2.chk == true ? '1' : '0') + '"}'
                _that.PointsSave.push(pnt2)
              }

              console.log(_that.PointsSave, '_that.PointsSave')

              var _pointsStr = '[' + _that.PointsSave.join(',') + ']'
              var hCul = 0;

              for (let i = 0; i < _that.Drivers.length; i++) {
                if (4 == _that.Drivers[i].PositionId) {
                  _that.driverUser = _that.Drivers[i].DriverId + ''
                  break
                }
              }

              var _dat = {
                pred: _that.gn.crypt(_pred), //edit na predefiniran nalog
                vid: _that.gn.crypt(_that.selectedVehicleID),
                driver1: _that.gn.crypt(dr1 + '' == '-1' ? 0 : dr1),
                driver2: _that.gn.crypt(dr2 + '' == '-1' ? 0 : dr2),
                driver3: _that.gn.crypt(dr3 + '' == '-1' ? 0 : dr3),
                driver4: _that.gn.crypt(dr4 + '' == '-1' ? 0 : dr4),

                job1: _that.gn.crypt(j1 + '' == '-1' ? 0 : j1),
                job2: _that.gn.crypt(j2 + '' == '-1' ? 0 : j2),
                job3: _that.gn.crypt(j3 + '' == '-1' ? 0 : j3),
                job4: _that.gn.crypt(j4 + '' == '-1' ? 0 : j4),

                weapon1: _that.gn.crypt(w1 + '' == '-1' ? 0 : w1),
                weapon2: _that.gn.crypt(w2 + '' == '-1' ? 0 : w2),
                weapon3: _that.gn.crypt(w3 + '' == '-1' ? 0 : w3),
                weapon4: _that.gn.crypt(w4 + '' == '-1' ? 0 : w4),

                dt: _that.gn.crypt(_dt),
                title: _that.gn.crypt(_that.RouteTitle),
                id: _that.gn.crypt(_that.EditId),
                cid: _that.gn.crypt(_that.gn.user.ClientId),
                uid: _that.gn.crypt(_that.gn.user.UserId),
                zad: _that.gn.crypt(parseInt(_that.idle)),
                Pause1: _that.gn.crypt(p1),
                Pause2: _that.gn.crypt(p2),
                Pause3: _that.gn.crypt(p3),
                Pause4: _that.gn.crypt(p4),
                Pause5: _that.gn.crypt(p5),
                TotalKm: _that.gn.crypt(totalkm),
                TotalTime: _that.gn.crypt(totaltime),
                optimized: _that.gn.crypt('optimized'),
                shortest: _that.gn.crypt('fastest'),
                culA: _that.gn.crypt(_that.selectedCultureId),
                culB: _that.gn.crypt(_that.selectedOperationId),
                culC: _that.gn.crypt(_that.selectedMaterialId),
                culD: _that.gn.crypt(_that.selectedMechanId),
                cul: _that.gn.crypt(hCul),
                points: _that.gn.crypt(_pointsStr),
                cnt: _that.gn.crypt(_pointsStr.length),
                driveruser: _that.gn.crypt(_that.driverUser)

              }

              var tmpvehicle = _that.selectedVehicleID

              // var _that = _that
              //raboti samo save na edit predefiniran nalog

              _that.gn._Post('/api/gn/saveroutenlb', _dat, function (_data) {
                _that.loadingData = false;
                _that.gn.tfBtn = false;
                if (_data.checkformesss == 'ok1') {
                  var dat2 = {
                    fromuid: _that.gn.crypt(_that.gn.user.UserId),
                    touid: _that.gn.crypt(_that.driverUser),
                    message: _that.gn.crypt('#BANK#' + _data.nalnum),//_that.gn.crypt('#BANK#' + _data.nalid),
                    id: _that.gn.crypt(_that.EditId),
                    naloghederid: _that.gn.crypt(_that.EditId)
                  }
                  _that.gn._Post('/api/gn/createMessageFromRoute', dat2, function (_data2) {
                  })
                }

                var info = ''


                var _dttmp = moment(_dt + ':00').add(_that._totaltime, 'seconds')
                var _dtstart = moment(_dt + ':00')
                var _now = moment()
                if ((_now) > (_dtstart) && (_now) < _dttmp) info = 'current'



                if (info == 'current') {
                  _that.gn._Post('/api/gn/getrouteinfolive', { vid: _that.gn.crypt(tmpvehicle) }, function (_data3) {
                    _that.gn.Vehicles[_that.gn.VehiclesDic[tmpvehicle]].routedetails = _data3[0].routeinfolive;
                  })

                }



                console.log('checkformess' + _data.checkformess)
                let alertModal = _that.modalCtrl.create(SuccsavedorderPage, {
                  id: _that.navParams.get("id") == undefined ? _data.nalid : _that.navParams.get("id"),
                  nid: _nid,
                  pred: _pred,
                  cb: function () {
                    _that.onlyloc = false;
                    _that.clearNalog();

                    //edit na predefiniran
                    console.log(_nid + ' ' + _pred)

                    if (_nid != -1) {
                      _that.ref.mdl.dismiss();
                      var cb = _that.navParams.get('cb')
                      cb();
                    }
                  }
                }, { cssClass: "modal-fullscreen5" });
                alertModal.present();

                // const toast = _that.toastCtrl.create({ message: _that.dic.l["SaveOrderDone"], duration: 3000, position: 'top' });
                // toast.present();

                // _that.clearNalog();

                // //edit na predefiniran
                // console.log(_nid + ' ' + _pred)

                // if (_nid != -1) {
                //   _that.ref.mdl.dismiss();
                //   var cb = _that.navParams.get('cb')
                //   cb();
                // }
              })

            }
          }
        ]
      });
      alert.present();
    }
    else {
      if (dajmidriver != '/') {
        _that.driverUser = _that.driveridvar + ''
      } else {
        for (let i = 0; i < _that.Drivers.length; i++) {
          if (4 == _that.Drivers[i].PositionId) {
            _that.driverUser = _that.Drivers[i].DriverId + ''
            break
          }
        }
      }
      var _data = {
        drivers: _that.Drivers,
        pois: _that.Points
      }

      var dr1 = "0"; if (_that.Drivers.length >= 1) { dr1 = _that.Drivers[0].DriverId }
      var dr2 = "0"; if (_that.Drivers.length >= 2) { dr2 = _that.Drivers[1].DriverId }
      var dr3 = "0"; if (_that.Drivers.length >= 3) { dr3 = _that.Drivers[2].DriverId }
      var dr4 = "0"; if (_that.Drivers.length >= 4) { dr4 = _that.Drivers[3].DriverId }

      var j1 = "0"; if (_that.Drivers.length >= 1) { j1 = _that.Drivers[0].PositionId }
      var j2 = "0"; if (_that.Drivers.length >= 2) { j2 = _that.Drivers[1].PositionId }
      var j3 = "0"; if (_that.Drivers.length >= 3) { j3 = _that.Drivers[2].PositionId }
      var j4 = "0"; if (_that.Drivers.length >= 4) { j4 = _that.Drivers[3].PositionId }

      var w1 = "0"; if (_that.Drivers.length >= 1) { w1 = _that.Drivers[0].WeaponId }
      var w2 = "0"; if (_that.Drivers.length >= 2) { w2 = _that.Drivers[1].WeaponId }
      var w3 = "0"; if (_that.Drivers.length >= 3) { w3 = _that.Drivers[2].WeaponId }
      var w4 = "0"; if (_that.Drivers.length >= 4) { w4 = _that.Drivers[3].WeaponId }

      var p1 = "0"; if (_that.SelPauses.length >= 1) { p1 = _that.SelPauses[0] }
      var p2 = "0"; if (_that.SelPauses.length >= 2) { p2 = _that.SelPauses[1] }
      var p3 = "0"; if (_that.SelPauses.length >= 3) { p3 = _that.SelPauses[2] }
      var p4 = "0"; if (_that.SelPauses.length >= 4) { p4 = _that.SelPauses[3] }
      var p5 = "0"; if (_that.SelPauses.length >= 5) { p5 = _that.SelPauses[4] }

      var _dt = moment(_that.startDateA).format('YYYY-MM-DD') + ' ' + _that.selectedTime

      _that.PointsSave = []
      for (var i = 0; i < _that.Points.length; i++) {
        var pnt1 = '{"txt":"' + _that.Points[i].t1.name + '", "lon":"' + _that.Points[i].t1.lon + '", "lat":"' + _that.Points[i].t1.lat + '", "ppid":"' + _that.Points[i].t1.ppid + '", "checked":"' + (_that.Points[i].t1.chk == true ? '1' : '0') + '"}'
        _that.PointsSave.push(pnt1)
        var pnt2 = '{"txt":"' + _that.Points[i].t2.name + '", "lon":"' + _that.Points[i].t2.lon + '", "lat":"' + _that.Points[i].t2.lat + '", "ppid":"' + _that.Points[i].t2.ppid + '", "checked":"' + (_that.Points[i].t2.chk == true ? '1' : '0') + '"}'
        _that.PointsSave.push(pnt2)
      }



      var _pointsStr = '[' + _that.PointsSave.join(',') + ']'
      var hCul = 0;

      var tmpvehicle = _that.selectedVehicleID


      var _dat = {
        pred: _that.gn.crypt(_pred), //edit na predefiniran nalog
        vid: _that.gn.crypt(_that.selectedVehicleID),
        driver1: _that.gn.crypt(dr1 + '' == '-1' ? 0 : dr1),
        driver2: _that.gn.crypt(dr2 + '' == '-1' ? 0 : dr2),
        driver3: _that.gn.crypt(dr3 + '' == '-1' ? 0 : dr3),
        driver4: _that.gn.crypt(dr4 + '' == '-1' ? 0 : dr4),

        job1: _that.gn.crypt(j1 + '' == '-1' ? 0 : j1),
        job2: _that.gn.crypt(j2 + '' == '-1' ? 0 : j2),
        job3: _that.gn.crypt(j3 + '' == '-1' ? 0 : j3),
        job4: _that.gn.crypt(j4 + '' == '-1' ? 0 : j4),

        weapon1: _that.gn.crypt(w1 + '' == '-1' ? 0 : w1),
        weapon2: _that.gn.crypt(w2 + '' == '-1' ? 0 : w2),
        weapon3: _that.gn.crypt(w3 + '' == '-1' ? 0 : w3),
        weapon4: _that.gn.crypt(w4 + '' == '-1' ? 0 : w4),

        dt: _that.gn.crypt(_dt),
        title: _that.gn.crypt(_that.RouteTitle),
        id: _that.gn.crypt(_that.EditId),
        cid: _that.gn.crypt(_that.gn.user.ClientId),
        uid: _that.gn.crypt(_that.gn.user.UserId),
        zad: _that.gn.crypt(parseInt(_that.idle)),
        Pause1: _that.gn.crypt(p1),
        Pause2: _that.gn.crypt(p2),
        Pause3: _that.gn.crypt(p3),
        Pause4: _that.gn.crypt(p4),
        Pause5: _that.gn.crypt(p5),
        TotalKm: _that.gn.crypt(totalkm),
        TotalTime: _that.gn.crypt(totaltime),
        optimized: _that.gn.crypt('optimized'),
        shortest: _that.gn.crypt('fastest'),
        culA: _that.gn.crypt(_that.selectedCultureId),
        culB: _that.gn.crypt(_that.selectedOperationId),
        culC: _that.gn.crypt(_that.selectedMaterialId),
        culD: _that.gn.crypt(_that.selectedMechanId),
        cul: _that.gn.crypt(hCul),
        points: _that.gn.crypt(_pointsStr),
        cnt: _that.gn.crypt(_pointsStr.length),
        driveruser: _that.gn.crypt(_that.driverUser)
      }


      // var _that = _that
      //raboti samo save na edit predefiniran nalog
      _that.gn._Post('/api/gn/saveroutenlb', _dat, function (_data) {
        _that.loadingData = false;
        _that.gn.tfBtn = false;
        if (_data.checkformesss == 'ok1') {
          var dat2 = {
            fromuid: _that.gn.crypt(_that.gn.user.UserId),
            touid: _that.gn.crypt(_that.driverUser),
            message: _that.gn.crypt('#BANK#' + _data.nalnum),//_that.gn.crypt('#BANK#' + _data.nalid),
            id: _that.gn.crypt(_that.EditId),
            naloghederid: _that.gn.crypt(_that.EditId)

          }
          _that.gn._Post('/api/gn/createMessageFromRoute', dat2, function (_data2) {

            // _that.sendImpulse()
          })

          // _that.gn._Post('/api/gn/getrouteinfolive', { vid: _that.gn.crypt(_that.selectedVehicleID) }, function (_data3) {

          //   debugger
          //   // _that.sendImpulse()

          // })

        }

        var info = ''


        var _dttmp = moment(_dt + ':00').add(_that._totaltime, 'seconds')
        var _dtstart = moment(_dt + ':00')
        var _now = moment()
        if ((_now) > (_dtstart) && (_now) < _dttmp) info = 'current'



        if (info == 'current') {
          _that.gn._Post('/api/gn/getrouteinfolive', { vid: _that.gn.crypt(tmpvehicle) }, function (_data3) {
            _that.gn.Vehicles[_that.gn.VehiclesDic[tmpvehicle]].routedetails = _data3[0].routeinfolive;
          })

        }

        let alertModal = _that.modalCtrl.create(SuccsavedorderPage, {
          id: _that.navParams.get("id") == undefined ? _data.nalid : _that.navParams.get("id"),
          nid: _nid,
          pred: _pred,
          cb: function () {
            _that.onlyloc = false;
            _that.clearNalog();

            //edit na predefiniran
            // console.log(_nid + ' ' + _pred)

            if (_nid != -1) {
              _that.ref.mdl.dismiss();
              var cb = _that.navParams.get('cb')
              cb();
            }
          }
        }, { cssClass: "modal-fullscreen5" });
        alertModal.present();

        // const toast = _that.toastCtrl.create({ message: _that.dic.l["SaveOrderDone"], duration: 3000, position: 'top' });
        // toast.present();

        // _that.clearNalog();

        // //edit na predefiniran
        // console.log(_nid + ' ' + _pred)

        // if (_nid != -1) {
        //   _that.ref.mdl.dismiss();
        //   var cb = _that.navParams.get('cb')
        //   cb();
        // }
      })

    }

  }

  saveNalog(_nid) {
    this.cntdata = 0;
    console.log('dali tuka vlagas')
    var _pred = this.EditType == 'pre' ? true : false; //dali e predefiniran
    if (_pred == true && _nid != -1 && this.RouteTitle == '') {
      const alert = this.alertCtrl.create({
        subTitle: this.dic.l["MustEnterRouteName"] + ' !',
        buttons: [this.dic.l['ok']]
      });
      alert.present();
      return
    }

    if (this.selectedVehicleID + '' == '-1') {
      const alert = this.alertCtrl.create({
        subTitle: 'Мора да изберете возило !',
        buttons: [this.dic.l['ok']]
      });
      alert.present();
      return
    }

    if (this.Drivers.length == 0) {
      const alert = this.alertCtrl.create({
        subTitle: 'Мора да внесете екипа !',
        buttons: [this.dic.l['ok']]
      });
      alert.present();
      return
    }

    if (this.Points.length == 0) {
      const alert = this.alertCtrl.create({
        subTitle: 'Мора да внесете точки на налогот !',
        buttons: [this.dic.l['ok']]
      });
      alert.present();
      return
    }

    var _pts = []
    _pts.push({ lon: this.gn.centralnabaza[0].lon, lat: this.gn.centralnabaza[0].lat })


    for (let p = 0; p < this.Points.length; p++) {
      if (this.Points[p].t1.lon != 0 || this.Points[p].t2.lon != 0) {
        if (this.Points[p].t1.name != 'Централна База - Скопје ул. Водњанска бр. 1')
          _pts.push({ lon: this.Points[p].t1.lon, lat: this.Points[p].t1.lat })
        if (this.Points[p].t2.name != 'Централна База - Скопје ул. Водњанска бр. 1')
          _pts.push({ lon: this.Points[p].t2.lon, lat: this.Points[p].t2.lat })
      }
    }
    _pts.push({ lon: this.gn.centralnabaza[0].lon, lat: this.gn.centralnabaza[0].lat })


    var _optimum = 'fastest'

    var _TollRoad = "no";
    var _Highways = "no";
    var _Ferry = "no";



    var _that = this

    if (this.hasChanges) {
      this._totaltime = 0
      if (this.SelPauses.length > 0) {
        for (let i = 0; i < this.SelPauses.length; i++) {
          this._totaltime += parseInt(this.SelPauses[i]) * 60
        }
      }


      var l = 49
      this._totaltime = this._totaltime + (parseInt(this.idle) * 60 * _pts.length)
      var _limitcnt = Math.ceil((_pts.length / l))
      this.RouteTotalDistance = 0;

      this.loadingData = true;
      setTimeout(function () {
        for (var c = 0; c < _limitcnt; c++) {
          _that.gn.tfBtn = true;
          (function (ind) {
            var _ptssub = _pts.slice(ind * l, ind * l + l);

            var _ptscheck = _pts.slice(ind * l + l, ind * l + l + 1);
            if (_ptscheck[0] != undefined) {
              _ptssub.push({ lon: _ptscheck[0].lon, lat: _ptscheck[0].lat })
            }
            setTimeout(function () {
              console.log('_ptssub.length ' + _ptssub.length)
              _that.gn.Socket.emit({ routeby: _that.gn.clientsettings.routeby, end: _limitcnt, cid: _that.gn.user.ClientId, uid: _that.gn.user.UserId, points: _ptssub, TollRoad: _TollRoad, Highways: _Highways, Ferry: _Ferry, Type: _optimum, Unit: "k" }, function (_data4) {
                _that.cntdata++;
                if (parseFloat(_data4.time) == 0) _that._totaltime = 0;
                if (parseFloat(_data4.distance) == 0) _that.RouteTotalDistance = 0;
                _that._totaltime = _that._totaltime + parseFloat(_data4.time)
                _that.RouteTotalDistance = parseFloat(_that.RouteTotalDistance + '') + parseFloat(_data4.distance)
                console.log('CHECK ROUTE ' + (parseInt(_that.cntdata + '') + ' ' + parseInt(_data4.end + '')))
                if (parseInt(_that.cntdata + '') == parseInt(_data4.end + '')) {
                  _that.setVariables(_nid, _pred, _that._totaltime, _that.RouteTotalDistance)
                }
              }, 'getDirections')

            }, 1500);
          })(c);
        }
      }, 200);
      // for (var c = 0; c < _limitcnt; c++) {
      //     var _ptssub = _pts.slice(c * l, c * l + l);

      //     var _ptscheck = _pts.slice(c * l + l, c * l + l + 1);
      //     if (_ptscheck[0] != undefined) {
      //       _ptssub.push({ lon: _ptscheck[0].lon, lat: _ptscheck[0].lat })
      //     }
      // this.gn.Socket.emit({ end: _limitcnt, cid: this.gn.user.ClientId, uid: this.gn.user.UserId, points: _ptssub, TollRoad: _TollRoad, Highways: _Highways, Ferry: _Ferry, Type: _optimum, Unit: "k" }, function (_data4) {
      //   _that.cntdata++;
      //   _that._totaltime = _that._totaltime + parseFloat(_data4.time)
      //   _that.RouteTotalDistance = _that.RouteTotalDistance + parseFloat(_data4.distance)
      //   console.log('CHECK ROUTE ' + (parseInt(_that.cntdata + '') + ' ' + parseInt(_data4.end + '')))
      //   if (parseInt(_that.cntdata + '') == parseInt(_data4.end + '')) {
      //     _that.setVariables(_nid, _pred, _that._totaltime, _that.RouteTotalDistance)
      //   }
      // }, 'getDirections')
      //}
    }
    else {
      if (this.SelPauses.length > 0) {
        for (let i = 0; i < this.SelPauses.length; i++) {
          this._totaltime += parseInt(this.SelPauses[i]) * 60
        }
      }
      _that._totaltime += parseInt(this.idle) * 60 * (this.Points.length * 2)
      _that.setVariables(_nid, _pred, _that._totaltime, _that.RouteTotalDistance)

    }
  }


  sendImpulse() {
    ///api/reloadchat
    this.gn._Post('/api/reloadchat', { cid: this.gn.crypt(this.gn.user.ClientId), fid: this.gn.crypt(this.gn.user.UserId), tid: this.gn.crypt(2287) }, function (_data) {

    })
  }


  openRedefinedForDownload(_pre, _onlyloc) {
    //_onlyloc = true - Prevzemi lokacii
    //_onlyloc = false - Prevzemi nalog
    this.onlyloc = _onlyloc;
    //this.downloadPre = _pre;
    var _that = this
    let profileModal = this.modalCtrl.create(LoadpredefinedPage, {
      onlyloc: _onlyloc,
      cb: function (_id) {
        //debugger
        _that.doLoadPredefined(_id)
      }
    });
    profileModal.present();
  }

  doLoadPredefined(_nid) {
    //debugger
    this.clearNalog();

    var _that = this
    this.gn._Post('/api/gn/getpredefinetroutesOne', { cid: this.gn.crypt(this.gn.user.ClientId), nid: this.gn.crypt(_nid) }, function (_data) {
      if (_that.onlyloc == false) {
        _that.RouteTitle = _data.rowsHeader[0].name;
        // _that.selectedVehicleName = _data.rowsHeader[0].vehiclename;
        // _that.selectedVehicleID = parseInt(_data.rowsHeader[0].vehicleid);

        if (_data.rowsHeader[0].driver1name != null && _data.rowsHeader[0].driver1name != undefined) {
          _that.Drivers.push({
            Driver: _data.rowsHeader[0].driver1name,
            DriverId: _data.rowsHeader[0].driverid1,
            Weapon: _data.rowsHeader[0].weapon1 == null ? 0 : _data.rowsHeader[0].weapon1,
            WeaponId: _data.rowsHeader[0].weaponid1 == null ? 0 : _data.rowsHeader[0].weaponid1,
            Position: _data.rowsHeader[0].jobname1 == null ? 0 : _data.rowsHeader[0].jobname1,
            PositionId: _data.rowsHeader[0].job1 == null ? 0 : _data.rowsHeader[0].job1
          })
        }
        if (_data.rowsHeader[0].driver2name != null && _data.rowsHeader[0].driver2name != undefined) {
          _that.Drivers.push({
            Driver: _data.rowsHeader[0].driver2name,
            DriverId: _data.rowsHeader[0].driverid2,
            Weapon: _data.rowsHeader[0].weapon2 == null ? 0 : _data.rowsHeader[0].weapon2,
            WeaponId: _data.rowsHeader[0].weaponid2 == null ? 0 : _data.rowsHeader[0].weaponid2,
            Position: _data.rowsHeader[0].jobname2 == null ? 0 : _data.rowsHeader[0].jobname2,
            PositionId: _data.rowsHeader[0].job2 == null ? 0 : _data.rowsHeader[0].job2
          })
        }
        if (_data.rowsHeader[0].driver3name != null && _data.rowsHeader[0].driver3name != undefined) {
          _that.Drivers.push({
            Driver: _data.rowsHeader[0].driver3name,
            DriverId: _data.rowsHeader[0].driverid3,
            Weapon: _data.rowsHeader[0].weapon3 == null ? 0 : _data.rowsHeader[0].weapon3,
            WeaponId: _data.rowsHeader[0].weaponid3 == null ? 0 : _data.rowsHeader[0].weaponid3,
            Position: _data.rowsHeader[0].jobname3 == null ? 0 : _data.rowsHeader[0].jobname3,
            PositionId: _data.rowsHeader[0].job3 == null ? 0 : _data.rowsHeader[0].job3
          })
        }
        if (_data.rowsHeader[0].driver4name != null && _data.rowsHeader[0].driver4name != undefined) {
          _that.Drivers.push({
            Driver: _data.rowsHeader[0].driver4name,
            DriverId: _data.rowsHeader[0].driverid4,
            Weapon: _data.rowsHeader[0].weapon4 == null ? 0 : _data.rowsHeader[0].weapon4,
            WeaponId: _data.rowsHeader[0].weaponid4 == null ? 0 : _data.rowsHeader[0].weaponid4,
            Position: _data.rowsHeader[0].jobname4 == null ? 0 : _data.rowsHeader[0].jobname4,
            PositionId: _data.rowsHeader[0].job4 == null ? 0 : _data.rowsHeader[0].job4
          })
        }

        var tmpPauses = []
        if (_data.rowsHeader[0].pause1 != 0) {
          tmpPauses.push(_data.rowsHeader[0].pause1 + ' ' + _that.dic.l["min"])
          _that.SelPauses.push(_data.rowsHeader[0].pause1)
        }
        if (_data.rowsHeader[0].pause2 != 0) {
          tmpPauses.push(_data.rowsHeader[0].pause2 + ' ' + _that.dic.l["min"])
          _that.SelPauses.push(_data.rowsHeader[0].pause2)
        }
        if (_data.rowsHeader[0].pause3 != 0) {
          tmpPauses.push(_data.rowsHeader[0].pause3 + ' ' + _that.dic.l["min"])
          _that.SelPauses.push(_data.rowsHeader[0].pause3)
        }
        if (_data.rowsHeader[0].pause4 != 0) {
          tmpPauses.push(_data.rowsHeader[0].pause4 + ' ' + _that.dic.l["min"])
          _that.SelPauses.push(_data.rowsHeader[0].pause4)
        }
        if (_data.rowsHeader[0].pause5 != 0) {
          tmpPauses.push(_data.rowsHeader[0].pause5 + ' ' + _that.dic.l["min"])
          _that.SelPauses.push(_data.rowsHeader[0].pause5)
        }

        _that.selectedBreak = tmpPauses.join(', ')

        _that.idle = _data.rowsHeader[0].tostay + '';
        //alert('Popolni route')
      }

      var tmpPois = _data.rowsDetail
      for (var i = 0; i < tmpPois.length; i++) {
        _that.Points.push({
          t1: {
            name: tmpPois[i].name,
            lon: tmpPois[i].long,
            lat: tmpPois[i].lat,
            ppid: tmpPois[i].ppid,
            chk: tmpPois[i].checked + '' == '1' ? true : false,
            note: '',
            noteid: -1,
            appcolor: tmpPois[i].appcolor,
          },
          t2: {
            name: tmpPois[i + 1] != undefined ? tmpPois[i + 1].name : '-',
            lon: tmpPois[i + 1] != undefined ? tmpPois[i + 1].long : 0,
            lat: tmpPois[i + 1] != undefined ? tmpPois[i + 1].lat : 0,
            ppid: tmpPois[i + 1] != undefined ? tmpPois[i + 1].ppid : 0,
            chk: tmpPois[i + 1] != undefined ? (tmpPois[i + 1].checked + '' == '1' ? true : false) : false,
            note: '',
            noteid: -1,
            appcolor: tmpPois[i + 1].appcolor,
          }
        })
        i += 1;
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/routing/routebank/neworderbank/neworderbank.ts